import { PricelistState } from "./state";

function getRoot(state:any): PricelistState {
    return state.reducer;
}

export function getSchools(state: any) {
    return getRoot(state).schools;
}

export function getCentres(state: any) {
    return getRoot(state).centres;
}

export function getCountries(state: any) {
    return getRoot(state).countries;
}

export function getProducts(state: any) {
    return getRoot(state).products;
}

export function getPricingYears(state: any) {
    return getRoot(state).pricingYears;
}

export function getSelectedProductType(state: any) {
    const root = getRoot(state);
    return root.selectedProductType;
}

export function getSelectedPricingYear(state: any) {
    const root = getRoot(state);
    return root.selectedPricingYearId;
}

export function getSelectedCentre(state: any) {
    const root = getRoot(state);
    return root.selectedCentreCode;
}

export function getPricelist(state: any) {
    const root = getRoot(state);
    return root.pricelist;
}

export function getDraftPricelist(state: any) {
    const root = getRoot(state);
    return root.draftPricelist;
}

export function getFormState(state: any) {
    const root = getRoot(state);
    return root.formState;
}

export function getIsLoading(state: any) {
    const root = getRoot(state);
    return root.isLoading;
}

export function getFormErrors(state: any) {
    const root = getRoot(state);
    return root.formErrors;
}

export function getErrorMessage(state: any) {
    const root = getRoot(state);
    return root.errorMessage;
}

